/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：ULrM
 */

// removed by extract-text-webpack-plugin
module.exports = {
  "iconFont": "iconFont_1CwOP"
}

/***/
